import { localStorageStore } from 'react-admin';

export const localStorageProvider = {
    getSetValue: <T>(itemKey: string, itemValue: T): T | undefined => {
        if (itemValue !== undefined) {
            localStorage.setItem(itemKey, JSON.stringify(itemValue));

            return itemValue;
        }

        const itemFromLocalStorage = localStorage.getItem(itemKey);

        return itemFromLocalStorage ? JSON.parse(itemFromLocalStorage) : undefined;
    },
    getRaConfig: (key: string) => {
        const value = localStorage.getItem(`RaStore.${key}`);
        if (value) {
            try {
                return JSON.parse(value);
            } catch (e) {
                return value;
            }
        }
        return undefined;
    },
    getRaStore: () => {
        const store = localStorageStore();

        store.setItem('sidebar.open', window.innerWidth > 1200);

        return store;
    },
};
